import { renderRichText } from '@storyblok/js';

export const customRenderText = richText => {
  return renderRichText(richText);
};

export const removeHtml = (str: string) => {
  return str.replace(/<[^>]*>?/gm, '');
};

export const fixHtml = (str: string) => {
  const entities = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
  };
  return (
    str
      .replace(/&amp;/g, '&')
      .replace(/&lt;|&gt;|&quot;|&#39;/g, match => entities[match])
      // Keep color; drop other inline styles (incl. text-align) so component
      // alignment / a-m|a-t|a-d overrides can still win. Never delete the tag.
      .replace(/<([^>\s]+)([^>]*)\sstyle="([^"]*)"([^>]*)>/gi, (_match, tag, before, style, after) => {
        const keep = [...style.matchAll(/color\s*:\s*[^;]+/gi)].map(m => m[0].trim());
        return `<${tag}${before}${after}${keep.length ? ` style="${keep.join('; ')};"` : ''}>`;
      })
      .replace(/<p>([<b>]{0,3})<(ul|ol|p)>/g, '$1<$2>')
      .replace(/<\/(ul|ol|p)>([</b>]{0,4})<\/p>/g, '</$1>$2')
  );
};
